import React, { useCallback, useEffect, useRef, useState } from "react";
import s from "./style.module.scss";
import Select from "shared/ui/Select";
import Button from "shared/ui/Button";
import Close from "./icons/Close";
import SecondaryInput from "shared/ui/SecondaryInput";
import { GetSupportList, SupportSendApi } from "./api";
import { useAppDispatch, useAppSelector } from "shared/redux/hooks";
import { userSelect } from "shared/redux/selectors/user";
import { api_key } from "shared/api/consts";
import { mallSelect } from "shared/redux/selectors/mall";
import { ISelectItem } from "shared/ui/Select/types";
import { showError } from "shared/lib/showError";
import { showSuccess } from "shared/lib/showSuccess";

const SupportForm: React.FC = () => {
  const dispatch = useAppDispatch();

  const { user_info } = useAppSelector(userSelect);
  const { id } = useAppSelector(mallSelect);

  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const [type, setType] = useState<ISelectItem>();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [typesList, setTypesList] = useState<ISelectItem[]>([]);
  const [images, setImages] = useState<any[]>([]);
  const [imagesPreview, setImagesPreview] = useState<any[]>([]);

  const [dataSending, setDataSending] = useState(false);

  const buttonDisabled =
    dataSending || email.trim() === "" || message.trim() === "";

  const handleSubmit = () => {
    setDataSending(true);

    const formData = new FormData();

    formData.append("api_key", api_key!);
    formData.append("mall_id", String(id));
    formData.append("user_id", String(user_info?.id!));

    formData.append("email", email);
    formData.append("request", message);
    formData.append("type_id", String(type?.id));
    //@ts-ignore
    if (images) formData.append("image", images);

    SupportSendApi(formData)
      .then((res) => {
        setImages([]);
        setImagesPreview([]);
        setMessage("");
        setEmail(user_info?.email ? user_info.email : "");

        showSuccess(
          dispatch,
          "Отправлено",
          "Ваше сообщение успешно отправлено!"
        );
      })
      .catch((e) => showError(e, dispatch))
      .finally(() => setDataSending(false));
  };

  const handleImageUpload = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      let reader = new FileReader();
      //@ts-ignore
      let file = (e.target as HTMLInputElement).files[0];

      reader.onloadend = () => {
        setImages([...images, file]);
        setImagesPreview([...imagesPreview, reader.result]);

        //@ts-ignore
        fileInputRef.current.value = null;
      };

      reader.readAsDataURL(file);
    },
    [images, imagesPreview]
  );

  const handleImageRemove = useCallback(
    (id: number) => {
      setImages(images.filter((image, key) => key !== id));
      setImagesPreview(imagesPreview.filter((image, key) => key !== id));
    },
    [images, imagesPreview]
  );

  useEffect(() => {
    if (user_info) {
      if (user_info.email) setEmail(user_info.email);

      GetSupportList(user_info.id).then((res) => {
        setTypesList(res);
        setType(res[0]);
      });
    }
  }, [user_info]);

  return (
    <form className={s.form}>
      <Select
        label="Тип"
        selectValues={typesList}
        value={type}
        setValue={setType}
      />

      <SecondaryInput
        id="email"
        label="E-mail для ответа"
        mask={String}
        setValue={setEmail}
        value={email}
        placeholder="Ваш e-mail"
      />

      <div className={`${s.wrap} ${s.column}`}>
        <label htmlFor="message">Ваше сообщение</label>
        <textarea
          placeholder="Сообщение"
          id="message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
      </div>

      <div className={s.bottom}>
        <div
          className={`${s.file} ${imagesPreview.length > 0 ? s.attached : ""}`}
        >
          {imagesPreview.length > 0 &&
            imagesPreview.map((image, key) => (
              <div key={key} className={s.preview}>
                <span onClick={() => handleImageRemove(key)}>
                  <Close />
                </span>
                <img src={image} alt="Preview" />
              </div>
            ))}

          {imagesPreview.length < 3 && (
            <label htmlFor="picture">
              <span>Прикрепить фото/чек</span>
            </label>
          )}

          <input
            onChange={handleImageUpload}
            ref={fileInputRef}
            type="file"
            id="picture"
          />
        </div>

        <Button
          disabled={buttonDisabled}
          className={s.button}
          onClick={handleSubmit}
        >
          Отправить
        </Button>
      </div>
    </form>
  );
};

export default SupportForm;
